export default __webpack_public_path__ + "static/media/bwp zoo logo web page.6805c811.png";